/* ==========================================================================
   IceFusion shared behaviour
   Ported from the static design system. Every block guards for its own
   markup, so a page only pays for what it actually renders.
   ========================================================================== */
(function () {
  "use strict";

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- Slide out menu ---- */
  (function () {
    var menu = $('#ice-menu'), openBtn = $('#ice-menu-open');
    if (!menu || !openBtn) return;

    function setMenu(open) {
      menu.classList.toggle('open', open);
      openBtn.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    }
    openBtn.addEventListener('click', function () { setMenu(true); });
    $$('[data-close]', menu).forEach(function (el) {
      el.addEventListener('click', function () { setMenu(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('open')) setMenu(false);
    });
  })();

  /* ---- Floating call button: reserve room at the foot of the page ---- */
  (function () {
    if ($('.ifz .callnow')) document.body.classList.add('has-callnow');
  })();

  /* ---- Category tabs plus the portrait card rail ----
     Scoped per section root so a page can carry more than one rail
     (the homepage range rail and a related products rail). ---- */
  $$('[data-ice-rail]').forEach(function (root) {
    var filters = $$('.filter[aria-controls]', root);
    var prevBtn = $('[data-rail="prev"]', root);
    var nextBtn = $('[data-rail="next"]', root);

    function activeScroller() {
      var pane = $('.pane.on', root);
      return pane ? $('.rail__scroll', pane) : $('.rail__scroll', root);
    }

    /* A pane with only a couple of cards does not scroll, so grey the arrows
       out rather than leaving them looking broken. */
    function syncArrows() {
      var sc = activeScroller();
      if (!sc || !prevBtn || !nextBtn) return;
      var max = sc.scrollWidth - sc.clientWidth;
      var scrollable = max > 1;
      prevBtn.disabled = !scrollable || sc.scrollLeft <= 1;
      nextBtn.disabled = !scrollable || sc.scrollLeft >= max - 1;
    }

    filters.forEach(function (f) {
      f.addEventListener('click', function () {
        filters.forEach(function (other) {
          var on = other === f;
          other.classList.toggle('on', on);
          other.setAttribute('aria-selected', String(on));
          var pane = document.getElementById(other.getAttribute('aria-controls'));
          if (pane) { pane.classList.toggle('on', on); pane.hidden = !on; }
        });
        syncArrows();
      });
    });

    $$('[data-rail]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sc = activeScroller();
        if (!sc) return;
        var card = $('.pcard', sc);
        var step = card ? card.getBoundingClientRect().width + 18 : sc.clientWidth * 0.8;
        sc.scrollBy({ left: btn.dataset.rail === 'next' ? step : -step, behavior: 'smooth' });
      });
    });
    $$('.rail__scroll', root).forEach(function (sc) {
      sc.addEventListener('scroll', syncArrows, { passive: true });
    });
    window.addEventListener('resize', syncArrows);
    syncArrows();
  });

  /* ---- Accordions: FAQ and product detail panels ---- */
  (function () {
    $$('.ifz .faq').forEach(function (item) {
      var btn  = $('.faq__q', item);
      var body = $('.faq__a', item);
      if (!btn || !body) return;

      /* single-open groups collapse their siblings, multi-open ones do not */
      var scope = item.closest('[data-accordion="multi"]');

      function open() {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
      function shut(el) {
        el.classList.remove('open');
        $('.faq__q', el).setAttribute('aria-expanded', 'false');
        $('.faq__a', el).style.maxHeight = '0px';
      }

      if (item.classList.contains('open')) requestAnimationFrame(open);
      else body.style.maxHeight = '0px';

      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('open');
        if (!scope) $$('.ifz .faq.open').filter(function (o) {
          return !o.closest('[data-accordion="multi"]');
        }).forEach(shut);
        if (wasOpen) shut(item); else open();
      });
    });

    window.addEventListener('resize', function () {
      $$('.ifz .faq.open .faq__a').forEach(function (el) {
        el.style.maxHeight = el.scrollHeight + 'px';
      });
    });
  })();

  /* ---- Reveal on scroll ---- */
  (function () {
    var items = $$('.ifz .rv');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  })();

  /* ---- Footer year ---- */
  (function () {
    var yr = $('#ice-yr');
    if (yr) yr.textContent = new Date().getFullYear();
  })();

  /* ---- Live cart count, so the header badge is right after an add ---- */
  document.addEventListener('ice:cart-updated', function (e) {
    var n = e && e.detail && typeof e.detail.item_count === 'number' ? e.detail.item_count : null;
    if (n === null) return;
    $$('.ifz .ico--cart .count').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  });
})();
